module.exports = __webpack_public_path__ + "img/headshot-annie-paz@2x.9119544d.jpg";